import { hotList } from "../../../mocks/guaData";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const rankColor = (i: number) =>
  i < 3
    ? "bg-primary-500 text-background-50"
    : i < 6
      ? "bg-accent-500 text-foreground-950"
      : "bg-background-200 text-foreground-600";

export default function HotList() {
  return (
    <section id="hot" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[0.38fr_0.62fr] lg:gap-12">
          <div>
            <SectionHead
              eyebrow="瓜田热搜 · 本周排行"
              title={
                <>
                  哪些瓜在热，
                  <br />
                  又为什么热
                </>
              }
              desc="热度不等于真相。这里为你标注每则热点的话题类型，并提示它最可能属于哪种传播模式，方便对照下文拆解。"
            />
            <Reveal delay={120}>
              <div className="rounded-xl border border-background-200 bg-background-100 p-5">
                <p className="text-sm font-semibold text-foreground-800">怎么看这份榜单？</p>
                <ul className="mt-3 space-y-2 text-sm text-foreground-600">
                  <li className="flex items-start gap-2">
                    <i className="ri-record-circle-fill mt-1 text-[10px] text-primary-500" aria-hidden="true"></i>
                    热度高的瓜，话题张力往往也更强。
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-record-circle-fill mt-1 text-[10px] text-accent-500" aria-hidden="true"></i>
                    若节奏异常顺滑，请多留意背后的剧本。
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-record-circle-fill mt-1 text-[10px] text-secondary-500" aria-hidden="true"></i>
                    点击瓜条可结合右侧专栏找同类解析。
                  </li>
                </ul>
              </div>
            </Reveal>
          </div>

          <div className="space-y-3">
            {hotList.map((h, i) => (
              <Reveal key={h.rank} delay={i * 40}>
                <a
                  href="#deep"
                  className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-primary-50/40 sm:p-4"
                >
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-heading text-sm font-black ${rankColor(i)}`}
                  >
                    {h.rank}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="flex flex-wrap items-center gap-2">
                      <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-900">
                        {h.tag}
                      </span>
                      <span className="font-heading text-base font-bold text-foreground-900 transition-colors group-hover:text-primary-600">
                        {h.title}
                      </span>
                    </span>
                    <span className="mt-1 hidden text-sm leading-relaxed text-foreground-600 sm:block">{h.brief}</span>
                  </span>
                  <span className="hidden shrink-0 items-center gap-1 text-xs font-semibold text-accent-600 md:flex">
                    <i className="ri-fire-line" aria-hidden="true"></i>
                    {h.heat}
                  </span>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}